import type { SnackSettings_SnackSettingsQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { GuestPageVisibilityQuestion } from "@/components/features-new/guest-page-visibility";

import { useInit } from "../model";
import { DesignSnackSettingsHeaderAndTabs, IslandLayoutSettings, IslandSnackSettings } from "./components";

type Props = {
	hotelID: string;
	data: SnackSettings_SnackSettingsQuery;
};

export const DesignSnackSettingsPresenter = ({ hotelID, data }: Props) => {
	const {
		snackSettingsViewModel,
		snackSettingsMethods,
		onUpdate,
		isValid, //

		snackLayoutSettingsViewModel,
		snackLayoutSettingsMethods,
	} = useInit({ data });

	return (
		<FeatureIslandContainer>
			{/* ヘッダーとタブ */}
			<DesignSnackSettingsHeaderAndTabs hotelID={hotelID} onUpdate={onUpdate} isValid={isValid} />

			{/* スナックの基本設定 */}
			<IslandSnackSettings
				snackSettingsMethods={snackSettingsMethods}
				snackSettingsViewModel={snackSettingsViewModel}
			/>

			{/* 検索エンジンへの表示 */}
			<FeatureIslandMainWithBackGround islandTitle="検索エンジンへの表示">
				<GuestPageVisibilityQuestion
					visibility={snackSettingsViewModel.guestPageVisibility.value}
					onChangeUnlisted={snackSettingsMethods.onSetGuestPageUnlisted}
				/>
			</FeatureIslandMainWithBackGround>

			{/* レイアウト設定 */}
			<IslandLayoutSettings
				snackLayoutSettingsMethods={snackLayoutSettingsMethods}
				snackLayoutSettingsViewModel={snackLayoutSettingsViewModel}
			/>
		</FeatureIslandContainer>
	);
};

DesignSnackSettingsPresenter.displayName = "DesignSnackSettingsPresenter";
